import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import CourseComponentForm from 'components/organisms/forms/CourseComponentForm'

import { crudActionsMap } from 'utils/helpers'

const CourseComponentCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.course-components')} / ${t('common.' + action)}`} />
      <PageBody>
        <CourseComponentForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default CourseComponentCrudPage
